module.exports = __webpack_public_path__ + "c_static/img/1-2关注店铺.0171e9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/1-2关注店铺.jpg
// module id = Ox6e
// module chunks = 33